/**
 * Callback function that indicates the chatbot tried to gain focus. It checks the uuid sent by the childframe with the stored chatbotId and also checks that the event type is 'chatFocused' before enabling navigation.
 *
 * @param {Object} ev - event from chatbot containing the close event type and uuid.
 * @param {Object} ev.data - data being passed by the chatbot to the M2 application
 * @param {string} ev.data.type - type of event being sent by the chatbot. Should be 'chatFocused'.
 * @param {string} ev.data.uuid - uuid of the chatbot frame.
 */
export var chatFocusedCallback = function chatFocusedCallback(_ref) {
  var _ref$data = _ref.data,
      type = _ref$data.type,
      uuid = _ref$data.uuid;

  if (type === 'chatFocused' && uuid && window.WF_CHATBOT.uuid === uuid) {
    window.WF_CHATBOT.enableNavigation();
    window.WFUI_BRIDGE.setNonCurrentIframeAriaHidden(true, uuid);
  }
};
/**
 * Adds event listener to close the chatbot cild frame.
 */

export var addChatFocused = function addChatFocused() {
  window.WFUI_BRIDGE.registerEventListener('chatFocused', chatFocusedCallback, window.WF_CHATBOT.uuid);
};